import React, { Fragment, useEffect, useState } from "react";
import {
  Box,
  Grid,
  Paper,
  TableCell,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import styles from "./Cart.module.css";
import DeleteIcon from "@mui/icons-material/Delete";
import SettingsIcon from "@mui/icons-material/Settings";
import { Link } from "react-router-dom";
import backBoardPic from "../../Assets/frames/BackingBoard.webp";
import Parse from "../../API/ParseServer";
const OrderUserArtworkItem: React.FC<{
  item: any;
}> = (props) => {
  const userArtwork = props.item.userArtwork;
  const area =
    Number(props.item.specifications.width) *
    Number(props.item.specifications.height);

  return (
    <TableRow
      key={props.item.objectId}
      sx={{
        "&:last-child td, &:last-child th": { border: 0 },
      }}
    >
      <TableCell component="th" scope="row">
        {userArtwork.get("resizedImage") ? (
          <img
            src={userArtwork.get("resizedImage").url()}
            alt="User Artwork"
            style={{ width: "50px" }}
          />
        ) : (
          <Box
            sx={{
              width: "50px",
              aspectRatio: 1,
              backgroundColor: "gray",
            }}
          ></Box>
        )}
      </TableCell>
      <TableCell align="center"> {props.item.title}</TableCell>
      <TableCell align="center">
        {props.item.specifications.width} x {props.item.specifications.height}{" "}
        cm
      </TableCell>
      <TableCell align="center">{props.item.quantity}</TableCell>{" "}
      <TableCell align="center"> £{props.item.price}</TableCell>
    </TableRow>
  );
};

export default OrderUserArtworkItem;
